import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function PharmacistAvailabilityDashboard() {
  const [requests, setRequests] = useState([]);

  const load = async () => {
    try {
      const res = await axios.get("/availability/requests/");
      setRequests(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const act = async (id, action) => {
    await axios.post(`/availability/requests/${id}/action/`, { action });
    load();
  };

  return (
    <div>
      <h2>Availability Requests</h2>

      {requests.map(r => (
        <div
          key={r.id}
          style={{ border: "1px solid #ccc", padding: 10, marginBottom: 10 }}
        >
          <p><b>Hospital:</b> {r.hospital_name}</p>
          <p><b>Customer:</b> {r.user_name}</p>
          <p>
            <b>Phone:</b>{" "}
            <a href={`tel:${r.callback_phone}`}>{r.callback_phone}</a>
          </p>

          {r.prescription_file && (
            <a href={r.prescription_file} target="_blank" rel="noreferrer">
              View Prescription
            </a>
          )}

          <div style={{ marginTop: 8 }}>
            <button onClick={() => act(r.id, "approve")}>
              Approve
            </button>
            <button
              onClick={() => act(r.id, "reject")}
              style={{ marginLeft: 6 }}
            >
              Reject
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
